import * as React from 'react';
import clsx from 'clsx';

import Text from '../../../../text/Text.jsx';

export type SurveyStartContainerProps = {
  headline: React.ReactNode;
  left?: React.ReactNode;
  right: React.ReactNode;
};

const SurveyStartContainer = ({
  headline,
  left,
  right
}: SurveyStartContainerProps) => (
  <div
    className={clsx('survey-start-container', {
      'survey-start-container--single': !left
    })}
  >
    <Text
      className="survey-start-container__headline"
      variant="headline-3-sans"
      tag="h2"
    >
      {headline}
    </Text>

    {left && <div className="survey-start-container__left">{left}</div>}

    <div className="survey-start-container__right">{right}</div>
  </div>
);

export default SurveyStartContainer;
